export function setDocumentTitle (title) {
  if (window.nfplusJsbridge) {
    window.nfplusJsbridge.setTitleBarAttribute({ title })
  }
  document.title = title
}
